import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/Card.tsx';

interface TotalBarProps extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
  /** Sformatowana kwota — pasek nie zna waluty ani znaku. */
  value: React.ReactNode;
}

/** Pasek domykający ekran jedną liczbą: „Wartość zmian", „Suma", „Do zapłaty". */
const TotalBar = ({ label, value, className, ...props }: TotalBarProps) => (
  <Card
    className={cn('flex items-center gap-4 px-7 py-[18px]', className)}
    {...props}
  >
    <span className="text-[15px] font-bold text-ink">{label}</span>
    <span className="ml-auto text-xl font-extrabold tabular-nums text-ink">
      {value}
    </span>
  </Card>
);

export default TotalBar;
